import { QuestionCircleOutlined } from '@ant-design/icons'
import { ActionType, ProColumns } from '@ant-design/pro-components'
import { DatePicker, Form, InputNumber, Popconfirm, Tooltip, message } from 'antd'
import FormItem from 'antd/es/form/FormItem'
import { ROUTES } from 'base/routes/routes'
import BoxContainer from 'base/ui/components/BoxContainer'
import CustomButton from 'base/ui/components/Button'
import CustomSelect from 'base/ui/components/CustomSelect'
import CustomProTable, { tablePagination } from 'base/ui/components/CustomTable'
import { CheckStatus, CloseStatus, Filter, Plus } from 'base/ui/components/Icons'
import dayjs from 'dayjs'
import useDebounce from 'hooks/useDebounce'
import { cloneDeep } from 'lodash'
import { observer } from 'mobx-react'
import { getDropdownCatalog } from 'pages/Common/dropdown'
import { ButtonDelete, ButtonEdit, ButtonNonActive } from 'pages/Components/FunctionButton'
import PageWrapper from 'pages/Components/PageWrapper'
import { SearchBox, SearchForm } from 'pages/Components/SearchBox'
import { SearchModel } from 'pages/model'
import { useEffect, useRef, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { CommonModel } from 'services/Main/common_services'
import { GiftModel } from 'services/Main/exchangeRewards_services'
import { commonPresenter, commonStore, exchangeRewardsPresenter, exchangeRewardsStore } from 'stores/root_store'
import { DATE_FORMAT_POST, PAGE_SIZE_DEFAULT } from 'utils/constants'
import { formatNumber } from 'utils/formatHelper'
import { checkPermission, useCheckPermission } from 'utils/permissionHelper'
import { customFilterOption } from 'utils/searchHelper'

const { RangePicker } = DatePicker;


// Danh sách quà tặng
const listGiftsPage = () => {
  return observer(() => {
    // Kiểm tra phân quyền
    useCheckPermission('INDEX');
    //=====================================CHUYỂN NGÔN NGỮ=====================================//
    const [form] = Form.useForm();
    const [open, setOpen] = useState({
      openDrawer: false,
      openModal: false,
      openConfirm: false,
    });

    // data table
    const [dataTable, setDataTable] = useState<GiftModel[]>([]);
    const tableRef = useRef<ActionType>();

    const navigate = useNavigate();
    // ---------------XỬ LÝ COLUMN VÀ TABLE-----------------------------------------------------------------------------------------------------
    const columns: ProColumns[] = [
      // stt
      {
        title: 'STT',
        dataIndex: 'stt',
        key: 'stt',
        align: 'center',
        width: 40,
      },
      // Đối tượng áp dụng
      {
        title: 'Đối tượng áp dụng',
        dataIndex: 'applicableObject',
        key: 'applicableObject',
        width: 150,
      },
      // Tên chương trình
      {
        title: 'Tên chương trình',
        dataIndex: 'programName',
        key: 'programName',
        width: 250,
        ellipsis: true
      },
      // Hạng thành viên
      {
        title: 'Hạng thành viên',
        dataIndex: 'membershipRank',
        key: 'membershipRank',
        width: 120,
      },
      // Hình thức quy đổi
      {
        title: 'Hình thức quy đổi',
        dataIndex: 'conversionForm',
        key: 'conversionForm',
        width: 150,
        ellipsis: true
      },
      // Giá trị quà tặng
      {
        title: 'Giá trị quà tặng',
        dataIndex: 'giftValue',
        key: 'giftValue',
        width: 100,
        render: (_, record) => (<>{formatNumber(record.giftValue, 0)}</>)
      },
      // Đơn vị
      {
        title: 'Đơn vị',
        dataIndex: 'unit',
        key: 'unit',
        width: 100,
      },
      // Thời hạn sử dụng
      {
        title: 'Thời hạn sử dụng',
        dataIndex: 'thoiHanSuDung',
        key: 'thoiHanSuDung',
        align: 'center',
        children: [
          {
            title: 'Từ',
            dataIndex: 'expiryDateFrom',
            key: 'expiryDateFrom',
            width: 100,
            valueType: 'dateTime',
            fieldProps: {
              format: 'DD/MM/YYYY',
            },
            align: 'center'
          },
          {
            title: 'Đến',
            dataIndex: 'expiryDateTo',
            key: 'expiryDateTo',
            width: 100,
            valueType: 'dateTime',
            fieldProps: {
              format: 'DD/MM/YYYY',
            },
            align: 'center'

          }
        ]
      },
      // Trạng thái
      {
        title: 'Trạng thái',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        render: (_, record) =>
          record.status ? (
            <CheckStatus width="14" className="!fill-[#0052cc] block mx-auto" />
          ) : (
            <CloseStatus width="14" className="!fill-red-500 block mx-auto" />
          ),
      },
      // Chức năng
      {
        title: 'Chức năng',
        dataIndex: 'chucNang',
        key: 'chucNang',
        width: 100,
        render: (_, record) => (
          <div className="flex gap-2">
            <Popconfirm
              title="Xóa"
              description="Bạn có chắc muốn xóa không?"
              onConfirm={async () => {
                const res = await exchangeRewardsPresenter.deleteGift(record.id, 'Hard')
                if (res.isSuccess) {
                  message.success(res.message)
                  tableRef.current?.reload()
                }
              }}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            >
              <Tooltip title="Xóa">
                <ButtonDelete />
              </Tooltip>
            </Popconfirm>
            <ButtonEdit onClick={() => navigate(`Edit/${record.id}`)} />
            <Popconfirm
              title="Ngưng hoạt động"
              description="Bạn có chắc muốn ngưng hoạt động không?"
              onConfirm={async () => {
                const res = await exchangeRewardsPresenter.deleteGift(record.id, 'Soft')
                if (res.isSuccess) {
                  message.success(res.message)
                  tableRef.current?.reload()
                }
              }}
              icon={<QuestionCircleOutlined style={{ color: 'red' }} />}
            >
              <Tooltip title="Ngưng hoạt động">
                <ButtonNonActive />
              </Tooltip>
            </Popconfirm>
          </div>
        ),
      },
    ];

    //--- search state ------------------------------------------------------------
    const [dataPaging, setDataPaging] = useState<SearchModel>({
      paging: {
        pageSize: PAGE_SIZE_DEFAULT,
        pageIndex: 1,
        orderBy: undefined,
        orderByDesc: undefined,
      },
    });

    const [dropdownObjectApply, setDropdownObjectApply] = useState<CommonModel[]>([])
    const [dropdownConversionMethod, setDropdownConversionMethod] = useState<CommonModel[]>([])
    const [membershipLevel, setMembershipLevel] = useState<CommonModel[]>([])
    const [measurementUnit, setMeasurementUnit] = useState<CommonModel[]>([])
    const [programList, setProgramList] = useState<CommonModel[]>([])

    // show filter form
    const showDrawer = () => {
      setOpen({ ...open, openDrawer: true });
    };
    // close filter form
    const onClose = () => {
      setOpen({ ...open, openDrawer: false });
    };

    const getListProgram = async (key?: string) => {
      await commonPresenter.getListProgram(commonStore, key)
      if (commonStore.commonRespone.isSuccess) {
        setProgramList(commonStore.commonRespone.data)
      }
    }
    const debounceListProgram = useDebounce(getListProgram, 500)

    useEffect(() => {
      debounceListProgram()
    }, [])



    useEffect(() => {
      getDropdownCatalog({ onSetDropdown: setDropdownObjectApply, params: { catalogTypeCode: 'ApplicableTarget' } })
      getDropdownCatalog({ onSetDropdown: setDropdownConversionMethod, params: { catalogTypeCode: 'ConversionMethod' } })
      getDropdownCatalog({ onSetDropdown: setMembershipLevel, params: { catalogTypeCode: 'MembershipLevel' } })
      getDropdownCatalog({ onSetDropdown: setMeasurementUnit, params: { catalogTypeCode: 'MeasurementUnit' } })
      debounceListProgram()
    }, [])


    const getDataTable = async (dataSearch: any) => {
      await exchangeRewardsPresenter.getListGift(exchangeRewardsStore, dataSearch);
      if (exchangeRewardsStore.listGiftRes.isSuccess) {
        const dataTemp = cloneDeep(exchangeRewardsStore.listGiftRes.data);
        setDataTable(dataTemp);
        return dataTemp;
      }
      setDataTable([]);
      return [];
    };

    return (
      <PageWrapper
        breadcrumb={[
          {
            text: 'Danh sách quà tặng',
          },
        ]}
        extras={
          <>
            {checkPermission('CREATE') && (
              <Link to={ROUTES.EXCHANGE_REWARDS.GIFTS.CREATE.LINK}>
                <CustomButton type="primary" icon={<Plus className="!fill-white" />}>
                  Thêm mới
                </CustomButton>
              </Link>
            )}
            <CustomButton onClick={showDrawer} type="primary" color="#EFF4F9" className="!px-0 w-8">
              <Filter className="!fill-primary" />
            </CustomButton>
          </>
        }
      >
        {/* Table */}
        <BoxContainer fullHeight>
          <CustomProTable
            bordered
            columns={columns}
            dataSource={dataTable}
            rowKey="id"
            actionRef={tableRef}
            scroll={{ x: 1600, y: 500 }}
            request={async (params = {}, sort, filter) => {
              const data = await getDataTable({
                ...dataPaging,
                paging: {
                  ...dataPaging.paging,
                  orderBy: Object.values(sort)[0] === 'ascend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                  orderByDesc:
                    Object.values(sort)[0] === 'descend' ? `${Object.keys(sort)[0].split(',').pop()}` : undefined,
                },
              });

              return {
                data: data,
                success: exchangeRewardsStore.listGiftRes.isSuccess,
              };
            }}
            pagination={{
              ...tablePagination(dataPaging, setDataPaging),
              total: exchangeRewardsStore.listGiftRes.paging?.totalCount,
            }}
            options={false}
          />
        </BoxContainer>


        {/* Form search */}
        <SearchBox
          onClose={onClose}
          className="lg:!w-[25%]"
          open={open.openDrawer}
          footer={
            <CustomButton
              htmlType="submit"
              className="my-auto ml-auto"
              type="primary"
              onClick={() => {
                const dataTempt = form.getFieldsValue()
                setDataPaging({
                  ...dataTempt,
                  expiryDateFrom: dataTempt.expiryDate?.[0] && dayjs(dataTempt.expiryDate?.[0]).format(DATE_FORMAT_POST),
                  expiryDateTo: dataTempt.expiryDate?.[1] && dayjs(dataTempt.expiryDate?.[1]).format(DATE_FORMAT_POST),
                  paging: { ...dataPaging.paging, pageIndex: 1 },
                });
                form.submit()
                tableRef.current?.reload();
                onClose()
              }}
            >
              Tìm kiếm
            </CustomButton>
          }
        >
          <SearchForm
            column={'col-1'}
            form={form}>
            {/* Đối tượng áp dụng */}
            <FormItem label="Đối tượng áp dụng" name={'applicableObject'}>
              <CustomSelect
                options={dropdownObjectApply.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                allowClear
                showSearch
                filterOption={customFilterOption} />
            </FormItem>
            {/* Hạng thành viên */}
            <FormItem label="Hạng thành viên" name={'membershipRank'}>
              <CustomSelect
                options={membershipLevel.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                showSearch
                allowClear
                filterOption={customFilterOption} />
            </FormItem>
            {/* Hình thức quy đổi */}
            <FormItem label="Hình thức quy đổi" name={'conversionForm'}>
              <CustomSelect
                options={dropdownConversionMethod.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                allowClear
                showSearch
                filterOption={customFilterOption} />
            </FormItem>
            {/* Giá trị quà tặng */}
            <FormItem label="Giá trị quà tặng" name={'giftValue'}>
              <InputNumber
                min={0} formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                style={{ width: '100%', textAlign: 'right' }}
              />
            </FormItem>
            {/* Đơn vị */}
            <FormItem label="Đơn vị" name={'unit'}>
              <CustomSelect
                options={measurementUnit.map((item) => ({
                  label: `${item.key} | ${item.value}`,
                  value: item.key,
                }))}
                allowClear
                filterOption={customFilterOption} />
            </FormItem>
            <FormItem label="Tên chương trình" name={'programId'} >
              <CustomSelect
                options={programList.map((item) => ({
                  label: `${item.value}`,
                  value: item.key,
                }))}
                showSearch
                allowClear
                onSearch={(value) => value ? debounceListProgram(value) : debounceListProgram()}
                onClear={() => debounceListProgram()}
                filterOption={false} />
            </FormItem>
            {/* Thời hạn sử dụng */}
            <FormItem label="Thời hạn sử dụng" name={'expiryDate'}>
              <RangePicker
                format="DD/MM/YYYY"
                className="w-full"
              />
            </FormItem>
          </SearchForm>
        </SearchBox>


      </PageWrapper>

    )
  })
}

export default listGiftsPage